__turbopack_context__.v({
  "wrapper": "ShowMoreButton-module-scss-module__sZFXma__wrapper",
});
